const siteSection="CROSS:SELL:APPLY";

export const documentUploadDataLayer={
  "pageName": "CROSS:SELL:DOCUPLOAD LOAN",
  "siteSection": siteSection
};
export const documentUploadedStatusDataLayer={
  "pageName": "CROSS:SELL:DOCUSTATUS LOAN",
  "siteSection": siteSection
};
export const documentUnderReviewDataLayer={
  "pageName": "CROSS:SELL:REVIEW LOAN",
  "siteSection": siteSection
};
export const approvedStatusDataLayer={
  "pageName": "CROSS:SELL:APPROVED LOAN",
  "siteSection": siteSection
};
export const declinedStatusDataLayer={
  "pageName": "CROSS:SELL:DECLINED LOAN",
  "siteSection": siteSection
};
export const offerExpiredInPendDataLayer={
  "pageName": "CROSS:SELL:EXPIRED LOAN",
  "siteSection": siteSection
};
export const offerExpiredInNormalDataLayer={
  "pageName": "CROSS:SELL:EXPIRED LOAN",
  "siteSection": siteSection
};
